/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, NSFD){
	const a = 'is-active';
	const v = 'is-visible';
	const s = 'is-selected';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/index/common/svg/sprite.svg#arrow_left" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/index/common/svg/sprite.svg#arrow_right" /></svg></button>';
	const $path = NSFD.va.pathname;
	let sortItemsArr = [];

	// <商品TOP>新商品・リニューアル品ラベル情報取得用
	const getJSONnewProdLabel = (_jancode) => {
		return $.getJSON(`/index/json/${_jancode}/laebels.json`);
	};
	// <商品検索>ブランドごとのシリーズリスト取得用
	const getJSONseriesList = (_brand) => {
		return $.getJSON(`/index/json/${_brand}/series.json`);
	};
	// <カテゴリ別商品一覧>「その他のレシピを見る」パラメータ取得用
	const getJSONrecommendRecipeParam = (_catcode) => {
		return $.getJSON(`/index/recipe/ajax/recipe/${_catcode}/product_id2.json`);
	};
	// <カテゴリ別商品一覧>「おすすめレシピ」取得用
	const getJSONrecommendRecipeList = (_param) => {
		return $.getJSON(`/index/recipe/ajax/recipe/recommended_recipe.json${_param}`);
	};
	// <商品詳細>アレルギー情報取得用
	const getJSONallergyList = (_key) => {
		return $.getJSON(`/index/json/${_key}/allergies.json`);
	};
	// <商品詳細>この商品を使ったレシピ取得用
	const getJSONrecipeList = (_name) => {
		return $.getJSON(`/index/json/${_name}/used_recipe.json`);
	};
	// <商品詳細>この商品を使ったレシピ取得用
	const getJSONimgList = (_catcode) => {
		return $.getJSON(`/index/json/${_catcode}/image.json`);
	};

	// <商品トップ>新商品・リニューアル品のタグ付け
	const newProdLabel = () => {
		$('.prod-idx-new').find('.mod-boxLink05').each((idx, ele) => {
			let $thisImgSrc = $(ele).find('img').attr('src').split('/');
			let $thisCode = $thisImgSrc[$thisImgSrc.length -1].split('.')[0];

			getJSONnewProdLabel($thisCode).then((data) => {
				if (data.rt_bn_product.length) {
					let prodData = data.rt_bn_product[0].cf_p_tags;
					for(let i = 0; i < prodData.length; i++) {
						let labelKey = prodData[i]._key;

						if(labelKey === 'new') {
							$(ele).prepend('<span class="mod-boxLink05-new">NEW</span>');
						} else if(labelKey === 'renewal') {
							$(ele).prepend('<span class="mod-boxLink05-renewal">RENEW</span>');
						} else if(labelKey === 'frozen') {
							if($(ele).find('.mod-label-wrap').length) {
								$(ele).find('.mod-label-wrap').append('<span class="_frozen mod-label">冷凍食品</span>')
							} else {
								$(ele).find('.mod-boxLink05-txt').append('<div class="mod-label-wrap mt15">'+
								'<span class="_frozen mod-label">冷凍食品</span></span></div>');
							}
						} else if(labelKey === 'functional') {
							if($(ele).find('.mod-label-wrap').length) {
								$(ele).find('.mod-label-wrap').append('<span class="_function mod-label">機能性表示食品</span>')
							} else {
								$(ele).find('.mod-boxLink05-txt').append('<div class="mod-label-wrap mt15">'+
								'<span class="_function mod-label">機能性表示食品</span></span></div>');
							}
						}
					}
				}
			});
		});
	};

	// <商品検索結果・カテゴリ別商品一覧>
	const productsListEaseScroll = () => {
		var pos = $('#productsList').offset().top;

		if(NSFD.va.window.width < NSFD.va.device.sp) {
			pos -= 127;
		} else {
			pos -= 80;
		}
		$('html,body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
	};

	// <商品トップ・商品検索結果>
	const productsSearch = () => {
		const $filterBtn = $('.prod-search-filterBtn');
		const $filter = $('.prod-search-filter');
		const $search = $('.prod-search');
		const $clear = $('.js-prodSearch-clear');

		// 検索条件開閉
		$filterBtn.on('click', (e) => {
			$(e.currentTarget).toggleClass(a);
			$search.toggleClass(a);

			$filter.slideToggle();
		});
		// クリアボタン (検索条件をリセットする)
		$clear.on('click', (e) => {
			$('.prod-searchWrap').find('.mod-input').val('');
			$('.prod-searchWrap').find('.mod-select select').val('');
			$('select#series').find('option.js-option').remove();
		});

		// 選択したブランドによってシリーズを出し分ける
		$('select#brands').on('change', (e) => {
			$('select#series').find('option.js-option').remove();
			let brandCode = $(e.target).find('option:selected').val();
			getJSONseriesList(brandCode).then((data) => {
				if (data.series_list.length) {
					let seriesData = data.series_list; 
					for(let i = 0; i < seriesData.length; i++) {
						let seriesCode = seriesData[i].series_code;
						let seriesName = seriesData[i].series_name;
						$('select#series').append('<option value="'+seriesCode+'" class="js-option">'+seriesName+'</option>');
					}
				}
			});
		});

		// <検索結果>
		// ブランドを選択状態にする
		let param = location.search.replace('?', '').split('&');
		let selectedSeries;

		for(let i = 0; i < param.length; i++) {

			if(param[i].split('=')[0] === 'categories') {
				let selectedCat = param[i].split('=')[1]; 
				if(selectedCat !== '') {
					// 検索条件表示用の配列に追加
					sortItemsArr.push($('select#categories').find('option[value="'+selectedCat+'"]').text());
				}
			}

			if(param[i].split('=')[0] === 'series') {
				selectedSeries = param[i].split('=')[1];
			}

			if(param[i].indexOf('brand') !== -1) {
				let selectedBrand = param[i].split('=')[1];
				if(selectedBrand !== '') {
					// ブランドが選択されている場合は検索条件を開く
					$filter.show();
					$('.prod-search-filterBtn').addClass(a);
					$('form.prod-searchWrap > .prod-search').addClass(a);

					// 検索条件表示用の配列に追加
					sortItemsArr.push($('select#brands').find('option[value="'+selectedBrand+'"]').text());

					getJSONseriesList(selectedBrand).then((data) => {
						if (data.series_list.length) {
							let seriesData = data.series_list; 
							for(let j = 0; j < seriesData.length; j++) {
								let seriesCode = seriesData[j].series_code;
								let seriesName = seriesData[j].series_name;
								if(selectedSeries === seriesCode) {
									$('select#series').append('<option value="'+seriesCode+'" class="js-option" selected="selected">'+seriesName+'</option>');
									sortItemsArr.push(seriesName);
								} else {
									$('select#series').append('<option value="'+seriesCode+'" class="js-option">'+seriesName+'</option>');
								}
							}
						}
					});
				}
			}
		}

		window.onload = () => {
			// 検索条件をテキスト表示
			if(sortItemsArr.length) {
				$('.js-prodSearch-sortItems span').text(sortItemsArr.join('、'));
				$('.js-prodSearch-sortItems').addClass(v);
			}

			// 商品リストまでスクロール
			if($('.mod-select option[selected="selected"]').length || $('.mod-input').val() !=='') {
				productsListEaseScroll();
			}
		}
	};

	// <商品検索>検索結果が0件の場合
	const prodSearchResultNone = () => {
		if($('.pure-g._shadow li').length == 0) {
			$('.js-prodSearchList-isNone').addClass(v);
			$('.mod-paginate02').addClass('di_none');
		}
	};

	// <カテゴリ別商品一覧>検索条件PC／SPで出しわけ
	const productsCatSortSwitch = () => {
		// 検索条件出しわけ（PC・SP）
		let widthFlag = '';
		const widthCheck = () => {
			let winWidth = $(window).width();
			if(winWidth <= NSFD.va.device.desktop && widthFlag != 'sp') {
				// SP処理
				widthFlag = 'sp';
				$('.js-prodSort-btn').each((idx,ele) => {
					let thisCat = $(ele).attr('data-cat');
					$(`.prod-cat-filter-block[data-cat="${thisCat}"]`).clone().insertAfter(ele).addClass('_sp');
				});
				$('.prod-cat-filter-block').not('._sp').addClass('is-hidden');
				$('.js-prodSort-btn').click((e) => {
					let thisCat = $(e.currentTarget).attr('data-cat');
					$(e.currentTarget).next('.prod-cat-filter-block._sp').toggleClass(v);
				});
			} else if(winWidth > NSFD.va.device.desktop && widthFlag != 'pc') {
				// PC処理
				widthFlag = 'pc';
				$('.prod-cat-filter-block._sp').remove();
				$('.prod-cat-filter-block').removeClass('is-hidden');
				$('.js-prodSort-btn').mouseover((e) => {
					let thisCat = $(e.currentTarget).attr('data-cat');
					$('.prod-cat-filter-block').removeClass(v)
					$(`.prod-cat-filter-block[data-cat="${thisCat}"]`).addClass(v);
				});
				$('.prod-cat-filter').mouseover((e) => {
					if(!$(e.target).closest('.prod-cat-filter-block, .mod-button').length) {
						$('.prod-cat-filter-block').removeClass(v);
					}
				});
			}
		}
		$(window).on('resize', function() {
			widthCheck();
		}).resize();
	};

	// <カテゴリ別商品一覧>検索条件
	const productsCatSort = () => {
		const $clear = $('.js-prodSort-clear');
		const $map = NSFD.va.pathname.split('/');
		const $param = location.search;

		// 商品リストまでスクロール
		if($param !== '') {
			productsListEaseScroll();
		}

		// 子カテゴリ絞り込み
		if($('.js-prodSort-param').length) {
			let $setParam = '';
			let selectParam = '';
			let paramTagArr = [];
			let pair = location.search.substring(1).split('&');
			for(let i = 0; pair[i]; i++) {
				let keyValue = pair[i].split('=');
				paramTagArr.push(keyValue[1]);
			}

			// カレント
			if($param !== '') {
				let $sortItem = [];
				$('.js-prodSort-param').each((idx, ele) => {
					let thisChildCat = $(ele).attr('data-childcat');
					if(paramTagArr.indexOf(thisChildCat) !== -1) {
						$(ele).addClass(a);
						$('.js-sortCategory-name').removeClass('di_none');
						$sortItem.push($(ele).find('.prod-cat-filter-item-txt').text());
					}
				});
				$('.js-sortCategory-name .js-text').text($sortItem.join('、'));
			}

			$('.js-prodSort-param').on('click', (e) => {
				const $this = $(e.currentTarget);
				let selectCat = $this.attr('data-childcat');
				let selectCatText = $this.find('.prod-cat-filter-item-txt').text();
				$this.toggleClass(a);
			});

			// 検索
			$('.js-prodSort-submit').on('click', (e) => {
				$('.js-prodSort-param.is-active').each((idx, ele) => {
					let selectSortCat = $(ele).attr('data-childcat');
					let selectSortName = $(ele).find('.prod-cat-filter-item-txt').text();

					if(idx === 0) {
						selectParam += '?child_category=' + selectSortCat;
					} else {
						selectParam += '&child_category=' + selectSortCat;
					}
				});

				location.href = $path + selectParam;
			});

			// クリアボタン
			$('.js-prodSort-clear').on('click', (e) => {
				$('.js-prodSort-param').removeClass(a);
			});
		}

		// タグによる絞り込み
		if($('.js-prodSort-tag').length) {
			let $thisTag;
			let $sortItem = [];
			let $setParam = $param;
			// パラメータtagキーを配列に格納
			let paramTagArr = [];
			let pair = location.search.substring(1).split('&');
			for(let i = 0; pair[i]; i++) {
				let keyValue = pair[i].split('=');
				paramTagArr.push(keyValue[1]);
			}

			// カレント
			$('.prod-cat-filter-block').find('.prod-cat-filter-item').each((idx, ele) => {
				let $selectedTag;
				$thisTag = $(ele).attr('data-tag');

				if(paramTagArr.indexOf($thisTag) !== -1) {
					$selectedTag = $thisTag;
					// 選択された項目をアクティブにする
					$(ele).addClass(a);
					let thisName = $(ele).find('.prod-cat-filter-item-txt').text();
					let thisSortCat = $(ele).parents('.prod-cat-filter-block').addClass(s).attr('data-cat');
					$('.js-prodSort-btn[data-cat="'+ thisSortCat +'"]').addClass(a);
					$('.js-prodSort-btn[data-cat="'+ thisSortCat +'"]').find('.js-selectItem').text(thisName);
					$sortItem.push(thisName);
					$('.js-sortCategory-name').removeClass('di_none');
				}
			});
			$('.js-sortCategory-name .js-text').text($sortItem.join('、'));

			// 検索条件セット
			$('.prod-cat-filter-block').find('.prod-cat-filter-item').on('click', (e) => {
				let $this = $(e.currentTarget);
				let selectParam = '';
				let paramKey = 'tag';
				let catNameArr = [];
				// クリックした項目をセット
				$this.parents('.prod-cat-filter-block').find('.prod-cat-filter-item').removeClass(a);
				$this.addClass(a);
				let thisSortCat = $this.parents('.prod-cat-filter-block').attr('data-cat');
				$('.js-prodSort-btn[data-cat="'+ thisSortCat +'"]').addClass(a);
				$('.js-prodSort-btn[data-cat="'+ thisSortCat +'"]').find('.js-selectItem').text($this.text());

				// 選択された項目をパラメータにセット
				$('.prod-cat-filter-item.is-active').each((idx, ele) => {
					if(!$(ele).parents('.prod-cat-filter-block').hasClass('is-hidden')) {
						let selectSortCat = $(ele).parents('.prod-cat-filter-block').attr('data-cat');
						let selectItem = $(ele).attr('data-tag');
						let selectItemName = $(ele).find('.prod-cat-filter-item-txt').text();

						if(selectSortCat.indexOf('brand') !== -1) {
							paramKey = 'brands';
							catNameArr.push(encodeURIComponent(selectItemName));
						}

						if(idx === 0) {
							selectParam += '?'+ paramKey +'=' + selectItem;
						} else {
							selectParam += '&'+ paramKey +'=' + selectItem;
						}

					}
				});
				$setParam = selectParam +'&child_category_name='+ catNameArr.join(',');
			});
			// 検索
			$('.js-prodSort-submit').on('click', (e) => {
				location.href = $path + $setParam;
			});

			// クリアボタン
			$('.js-prodSort-clear').on('click', (e) => {
				$('.prod-cat-filter-item').removeClass(a);
				$('.prod-cat-filter-item').removeClass(a);
				$('.js-prodSort-btn').removeClass(a);
				$('.js-selectItem').text('');
				$setParam = '';
			});

		}
	};

	// <カテゴリ別商品一覧>おすすめレシピ
	const recommendRecipe = () => {
		if($('.js-recommendRecipe').length) {
			let thisCatCode = $path.split('/')[$path.split('/').length -2];
			let prodParentCat = $('.mod-head01-ja').text();
			let setParam = '';
			let setLink = '/index/recipe/search.html';
			let recipeHTML = '';
			getJSONrecommendRecipeParam(thisCatCode).then((data) => {
				let prodList = data.rt_bn_product;
				if(prodList.length) {
					for(let i = 0; i < prodList.length; i++) {
						let prodID = prodList[i].rt_cf_product_id;
						if(i === 0) {
							setParam += '?product_id='+ prodID;
						} else {
							setParam += '&product_id='+ prodID;
						}
					}
				}
				getJSONrecommendRecipeList(setParam).then((prodData) => {
					let recipeList = prodData.rt_bn_recipe;
					if(recipeList.length) {
						for(let j = 0; j < recipeList.length; j++) {
							let recipeName = recipeList[j].rt_cf_title;
							let recipeUrl = recipeList[j].rt_cf_detail_page_url;
							let recipeImge = recipeList[j].rt_cf_thumbnail_src;
							recipeHTML = '<li class="pure-u-1-4 pure-u-md-1-2 space-u-20-child" style="order:'+j+';">'+
							'<a href="'+ recipeUrl +'" class="mod-boxLink03" data-mh="block">'+
							'<figure class="mod-boxLink03-img"><img src="'+ recipeImge +'" alt="'+recipeName+'" class="width-u-100">'+
							'</figure><div class="mod-boxLink03-txtBlock">'+
							'<p class="mod-boxLink03-txtBlock-tit" data-mh="title">'+ recipeName +'</p>'+
							'</div></a></li>';
							$('.js-recommendRecipe .pure-g').append(recipeHTML);
							$('.js-recommendRecipe').addClass(v);
						}
						if($('.js-recommendRecipe .prod-cat-recommend-slider li').length < 4) {
							// 4件未満の場合はレシピTOP遷移
							$('.js-recommendRecipe').find('.mod-button').attr('href', '/index/recipe/').removeClass('di_none');
							$('.js-recommendRecipe').find('.mod-button-text').text('その他のレシピを見る');
						} else {
							setLink += setParam +'&product_category_name='+ encodeURIComponent(prodParentCat);
							$('.js-recommendRecipe').find('.mod-button').attr('href', setLink).removeClass('di_none');
						}

						// ブランド tabletとSPのみスライド
						function recipeliderSetting(){
							var width = $(window).width();
							if(width < 768) {
								$('.js-recipe-slider').not('.slick-initialized').slick({
									infinite: true,
									speed: 1000,
									autoplaySpeed: 4000,
									autoplay: true,
									slidesToShow: 2,
									arrows: true,
									prevArrow: arrowPrev,
									nextArrow: arrowNext,
									dots: false,
									// appendArrows: $('.prod-cat-recommend-slider-arrows')
								});
							} else {
								$('.js-recipe-slider.slick-initialized').slick('unslick');
							}
						}
						recipeliderSetting();

						$(window).resize(function(){
							recipeliderSetting();
						});
					}
				});
			});
		}
	};

	// <カテゴリ別商品一覧>知る・学ぶ出しわけ
	const learnBlock = () => {
		if($path === '/index/products/pasta/' || $path === '/index/products/pasta/index.html') {
			$('.js-learnBlock[data-name="pasta"]').removeClass('di_none');
		} else {
			$('.js-learnBlock[data-name="flour"]').removeClass('di_none');
		}
	};

	// <新商品・リニューアル品>絞り込み
	const newProdCurrent = () => {
		if($('.prod-cat-filter').length) {
			let $param = location.search;
			// カレント
			if($param !== '') {
				$('.js-prodSort-btn').each((idx, ele) => {
					if($(ele).attr('href').indexOf($param) !== -1){
						$(ele).addClass(a);
					}
				});
			}
			// クリアボタン
			$('.js-prodSort-clear').on('click', (e) => {
				location.href = $path;
			});
		}

	};

	// <商品詳細>アレルゲン情報
	const allergyList = () => {
		let $prodCode = $('.js-allergy').attr('data-id');
		// let specifiedArr = [];
		// let semiSpecifiedArr = [];
		// let otherArr = [];
		let allergyArr = [];

		getJSONallergyList($prodCode).then((data) => {
			if (data.rt_bn_allergies_list.length) {
				let allergyData = data.rt_bn_allergies_list[0]

				// 法令で規定する特定原材料8品目
				for(let i = 1; i <= 8; i++) {
					let thisData = allergyData['rt_cf_specified_material_0'+ i];
					if(thisData !== null && thisData !== undefined) {
						allergyArr.push(thisData.name);
					}
				}
				// 表示を推奨する特定原材料に準ずるもの20品目
				for(let i = 1; i <= 20; i++) {
					if (String(i).length === 1) {
						i = '0'+i;
					}
					let thisData = allergyData['rt_cf_semi-specified_material_'+ i];
					if(thisData !== null) {
						allergyArr.push(thisData.name);
					}
				}
				// その他
				for(let i = 1; i <= 20; i++) {
					if (String(i).length === 1) {
						i = '0'+i;
					}
					let thisData = allergyData['rt_cf_other_material_'+ i];
					if((Object.keys(allergyData).indexOf('rt_cf_other_material_'+ i) !== -1) === true) {
						if(thisData !== null) {
							allergyArr.push(thisData.name);
						}
					}
				}
				
				// コンタミ表示
				const contamiArr = allergyData.rt_cf_pa_contami;
				if(contamiArr !== null && contamiArr !== undefined) {
					contamiArr.content.forEach(element => {
						if (typeof element === 'object' && element !== null) {
							$('.js-allergy-contami').append('<br>');
						} else {
							$('.js-allergy-contami').append(element);
						}
					});
				} else {
					$('.js-allergy-contami').remove();
				}

				// 出力
				if(allergyArr.length) {
					$('.js-allergy-specified').text(allergyArr.join('・'));
					$('.js-allergy').addClass(v);
				} else {
					$('.js-allergy').remove();
				}
				
			} else {
				$('.js-allergy').remove();
			}
		});
	};
	// <商品詳細>栄養成分表示、その他のラインナップ
	const prodDetailItems = () => {
		// 栄養成分表示
		if(!$('.js-prod-nutritional .js-prod-nutritional-item').length) {
			$('.js-prod-nutritional').remove();
		}
		// その他のラインナップ
		if(!$('.js-prod-lineup li').length) {
			$('.js-prod-lineup').remove();
		}

		// ナトリウム値がある場合、（食塩相当量）にて表示／無い場合、食塩相当量にて表示
		let sodium = $('.js-sodium');
		let salt01 = $('.js-salt01');
		let salt02 = $('.js-salt02');
		if(sodium.length && salt01.length) {
			salt01.remove();
		} else if(!sodium.length && salt02.length) {
			salt02.remove();
		}

	};
	// <商品詳細>この商品を使ったレシピ
	const prodDetailRecipeList = () => {
		let thisProdName = $('.rt_cf_p_group').text();
		getJSONrecipeList(thisProdName).then((data) => {
			if (data.rt_bn_recipe_list.length) {
				let recipeData = data.rt_bn_recipe_list; 
				let recipeHtml;
				for(let i = 0; i < recipeData.length; i++) {
					let recipeName = recipeData[i].rt_cf_r_thumbnail_alt;
					let recipeImg = recipeData[i].rt_cf_r_thumbnail;
					let recipeUrl = recipeData[i].rt_cf_recipe_ref;
					recipeHtml = '<li class="pure-u-1-4 pure-u-md-1-2 space-u-20-child rt_bn_recipe_list">'+
					'<a href="'+ recipeUrl +'" class="mod-boxLink03 rt_cf_recipe_ref" data-mh="block">'+
					'<figure class="mod-boxLink03-img">'+
					'<img src="'+ recipeImg +'" alt="'+ recipeName +'" class="width-u-100 rt_cf_r_thumbnail" title="'+ recipeName +'">'+
					'</figure><div class="mod-boxLink03-txtBlock">'+
					'<p class="mod-boxLink03-txtBlock-tit rt_cf_r_title" data-mh="title">'+ recipeName +
					'</p></div></a></li>';
					$('.prod-cat-recommend-slider').append(recipeHtml);
				}

				// 4件未満の場合、「その他のレシピを見る」のリンク先をレシピTOPに変更
				if(recipeData.length < 4){
					$('.js-otherRecipe').attr('href','/index/recipe/');
				}
			} else {
				$('.js-prod-recipe').remove();
			}
		});
	};

	// <商品詳細>その他のラインナップ
	const lineupSlider = () => {
		$('.prod-detail-lineup-slider').slick({
			infinite: true,
			speed: 1500,
			autoplay: true,
			autoplaySpeed: 5000,
			slidesToShow: 4,
			arrows: true,
			dots: false,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						//appendArrows: $('.prod-detail-lineup-slider-arrows'),
					}
				}
			]
		});
	};

	// <商品詳細>ブランドページへのリンク（カテゴリーごとに出しわけ）
	const prodDetailBrandLink = () => {
		let thisCatPath = $('.mod-topicPath-a.rt_cf_breadcrumb_category_ref').attr('href').split('/');
		let thisCat = thisCatPath[thisCatPath.length -2];
		$('.js-brandLink').each((idx, ele) => {
			if($(ele).attr('data-name').indexOf(thisCat) !== -1) {
				$(ele).addClass(v);
			}
		});

		// ナチュブラン
		if($path.indexOf('4902110356120') !== -1 || $path.indexOf('4902110251159') !== -1) {
			$('.js-brandLink.natubran').addClass(v);
		}
	};
	// <商品詳細>SNSリンク（カテゴリーごとに出しわけ）
	const prodDetailSnsLink = () => {
		let thisCatPath = $('.mod-topicPath-a.rt_cf_breadcrumb_category_ref').attr('href').split('/');
		let thisCat = thisCatPath[thisCatPath.length -2];
		$('.js-snsLink').each((idx, ele) => {
			if($(ele).attr('data-name').indexOf(thisCat) !== -1) {
				$(ele).addClass(v);
			}
		});
		if($('.prod-detail-snsList .pure-g >li:visible').length === 1) {
			$('.prod-detail-snsList .pure-g').addClass('_center');
		}
	};

	// <商品詳細>画像カルーセル
	// ＜レシピ詳細＞スライド
	const productsDetailSlider = () => {
		const imgSlide = $('.js-products-detail-slider');
		if(imgSlide.length) {
			let jancode = $path.split('/')[$path.split('/').length -1].split('.')[0];
			getJSONimgList(jancode).then((data) => {
				let imgData = data.rt_bn_product;
				if (imgData.length) {
					let images = imgData[0].cf_p_image_detail;
					if(images.length) {
						for(let i = 0; i < images.length; i++) {
							if(i < 5 && images[i].cf_pp_img !== undefined) {
								let imgHtml = `<li>
									<figure class="__img">
										<img src="/index/products/product_file/file/${images[i].cf_pp_img}" alt="${images[i].cf_pp_img_alt}" title="${images[i].cf_pp_img_title}" class="jsonld_image">
									</figure>
								</li>`;
								imgSlide.append(imgHtml);
							}
						}
					}
				}
			}).then(() => {
				$('.js-products-detail-slider').slick({
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: true,
					dots: true,
					prevArrow: arrowPrev,
					nextArrow: arrowNext,
				});
			});
		}
	}

	// <商品カテゴリページ>原産地PDF(PV計測設定)
	const originPdfLink = () => {
		let thisPdf = $('.js-origin-pdfLink').attr('href');
		let thisCat = $path.split('/')[$path.split('/').length - 2];
		let onClickGa;
		if($path === '/index/products/sauce/' || $path === '/index/products/sauce/index.html') {
			// パスタソース
			onClickGa = `gtag('config','UA-174457606-1',{'page_location':'${thisPdf}', 'page_title':'日清フーズ　原料原産地（パスタソース）'});`;
		} else if(thisCat.indexOf('frozen_') !== -1) {
			// 冷凍食品
			onClickGa = `gtag('config','UA-174457606-1',{'page_location':'${thisPdf}','page_title':'日清フーズ　原料原産地（調理冷凍食品）'});`;
		}
		$('.js-origin-pdfLink').attr('onClick', onClickGa);
	};

	// 商品TOP
	if($path === '/index/products/' || $path === '/index/products/index.html') {
		newProdLabel();
	}
	// 商品TOP・商品検索ページ
	if($('.prod-searchWrap').length) {
		productsSearch();
	}
	// 新商品・リニューアル品
	if($path === '/index/products/tag/new_item/' || $path === '/index/products/tag/new_item/index.html') {
		newProdCurrent();
	}
	// 商品検索ページ
	if($path === '/index/products/search.html') {
		prodSearchResultNone();
	}
	// 商品カテゴリページ
	if($('.prod-cat').length) {
		productsCatSortSwitch();
		prodSearchResultNone();
		recommendRecipe();
		learnBlock();
		window.onload = () => {
			productsCatSort();
		};
	}
	// 商品詳細ページ
	if($('.prod-detail').length) {
		// アレルゲン情報
		allergyList();
		// 栄養成分表示、その他のラインナップ
		prodDetailItems();
		// この商品を使ったレシピ
		prodDetailRecipeList();
		// ブランドページへのリンク カテゴリーごとに出しわけ
		prodDetailBrandLink();
		// SNSリンク カテゴリーごとに出しわけ
		prodDetailSnsLink();
		// 商品画像スライド
		productsDetailSlider();

		// その他のラインナップ
		lineupSlider();
		$('.prod-detail-lineup-slider').addClass(v);

		$('.inc_foods_category').find('.mod-boxLink02-a').each((idx, ele) => {
			let catUrl = $(ele).attr('href');
			if($('.mod-topicPath-a.rt_cf_breadcrumb_category_ref').attr('href') === catUrl) {
				$(ele).addClass(a);
			}
		});
	}

	// 原産地PDF(PV計測設定)
	if($('.js-origin-pdfLink').length) {
		originPdfLink();
	}


})(window.jQuery, window.NSFD);
